import { ChatSeed } from '@/infrastructure/network/OpenAi/schema'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

export class Completions implements APIRequest<any> {
  response: any
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: ChatSeed
  constructor(query: ChatSeed) {
    this.params = query
    this.path = '/chat/completions'
  }
}
